import { Injectable, signal } from '@angular/core';
import { UserDTO } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class UserDetailsService {
    private _user = signal<UserDTO | null>(null);

    user = this._user.asReadonly();

    open(user: UserDTO) {
        this._user.set(user);
    }

    close() {
        this._user.set(null);
    }

    toggle(user: UserDTO) {
        const current = this._user();
        this._user.set(current?.username === user.username ? null : user);
    }
}
